import popupBlockedIcon from '@assets/svgs/pop-up.svg';
import styled from 'styled-components';

export const PopupBlockedIcon = styled.img.attrs({
  src: popupBlockedIcon,
  alt: 'Allow popups',
})`
  height: 22px;
  width: 77px;
  border: none;
  outline: none;
  position: absolute;
  top: 80px;
  right: 115px;
`;
